import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { ShieldCheck, X } from "lucide-react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import "../assets/css/rosterActionModals.css";

function AlertModal(props) {
  const {
    show,
    handleClose,
    message,
    actionFunction,
    cancel,
    okay,
    heading,
    appearance,
    showReasonBox = false,
    existingReason = "",
    alertData = {},
    editBox,
  } = props;

  const defaultInactiveHTML =
    alertData.language === "spanish"
      ? `<div class="message-container">
  <h4 style="line-height:27px;">Gracias por su interés en los <strong>Retiros Matrimoniales LOVESTRONG</strong>. 
  Lamentamos informarle que este Retiro LOVESTRONG ha alcanzado su capacidad máxima y ya no está aceptando inscripciones.</h4>

  <h4 style="line-height:27px;">Estamos planeando realizar otro Retiro LOVESTRONG en su parroquia en un futuro cercano. 
  Por favor contáctenos en <span><a href="mailto:info@LOVESTRONGMarriage.com">info@LOVESTRONGMarriage.com</a></span> 
  y envíenos sus nombres y direcciones de correo electrónico. Lo colocaremos en una <strong>Lista de Contacto Prioritaria</strong>, 
  para que podamos comunicarnos con usted con las fechas e información una vez que el próximo 
  <strong>${
    alertData?.parishName
      ? `${alertData.parishName[0].toUpperCase()}${alertData.parishName.slice(
          1
        )}`
      : ""
  } 
  (${
    alertData?.language
      ? `${alertData.language[0].toUpperCase()}${alertData.language.slice(1)}`
      : ""
  })</strong> 
  Retiro LOVESTRONG esté programado para el otoño de 2025.</h4>

  <h4 style="line-height:27px;">También puede visitar 
  <a href="https://LOVESTRONGMarriage.com" target="_blank">LOVESTRONGMarriage.com</a> 
  para obtener actualizaciones sobre futuros Retiros LOVESTRONG y eventos especiales.</h4>

  <h4 style="line-height:27px;">Gracias y que Dios los bendiga.</h4>
  <h4 style="line-height:27px;"><strong>- El equipo de LOVESTRONG</strong></h4>
</div>
`
      : `
    <div class="message-container">
      <h4 style="line-height:27px;">Thanks for your interest in <strong>LOVESTRONG Marriage Retreats</strong>. 
      We are so sorry, but this LOVESTRONG Retreat has exceeded capacity and is no longer accepting registrations.</h4>

      <h4 style="line-height:27px;">We are planning on hosting another LOVESTRONG Retreat at your parish in the near future. 
      Please contact us at <span><a href="mailto:info@LOVESTRONGMarriage.com">info@LOVESTRONGMarriage.com</a></span> 
      and send us your names and email address(es). You will be placed on a <strong>Priority Contact List</strong>, 
      so that we can reach out to you with dates and information once the next 
      <strong>${
        alertData?.parishName
          ? `${alertData.parishName[0].toUpperCase()}${alertData.parishName.slice(
              1
            )}`
          : ""
      } 
      (${
        alertData?.language
          ? `${alertData.language[0].toUpperCase()}${alertData.language.slice(
              1
            )}`
          : ""
      })</strong> 
      LOVESTRONG Retreat has been set for next Fall 2025.</h4>

      <h4 style="line-height:27px;">You can also visit 
      <a href="https://LOVESTRONGMarriage.com" target="_blank">LOVESTRONGMarriage.com</a> 
      to get updates on other future LOVESTRONG Retreats and special events.</h4>

      <h4 style="line-height:27px;">Thank you and God bless.</h4>
      <h4 style="line-height:27px;"><strong>- LOVESTRONG Staff</strong></h4>
    </div>
  `;

  const [reason, setReason] = useState("");

  useEffect(() => {
    // Only set reason on first open or if existingReason changes
    if ((showReasonBox || editBox) && show) {
      setReason((prev) =>
        existingReason && existingReason.trim() !== ""
          ? existingReason
          : prev || defaultInactiveHTML
      );
    } else {
      // Reset reason if modal is closed
      setReason("");
    }
  }, [existingReason, showReasonBox, editBox, show]);

  const handleConfirm = () => {
    if (showReasonBox && (!reason || reason.trim() === "")) {
      alert("Please provide a message before deactivating the retreat.");
      return;
    }
    actionFunction(reason);
  };

  const closeAlert = () => {
    handleClose();
    setReason("");
  };

  if (appearance === "confirm") {
    return (
      <Modal
        show={show}
        onHide={closeAlert}
        centered
        className="ram-modal"
        dialogClassName="ram-dialog"
        contentClassName="ram-content"
      >
        <div className="ram-shell">
          <header className="ram-header">
            <div className="ram-mark ram-mark--green" aria-hidden="true">
              <ShieldCheck size={20} />
            </div>
            <div className="ram-header-copy">
              <p className="ram-kicker">Super admin</p>
              <h2>Confirm this Retreat</h2>
              <p>
                Review the retreat below. Confirming records it as reviewed by
                a super admin.
              </p>
            </div>
            <button
              type="button"
              className="ram-close"
              onClick={closeAlert}
              aria-label="Close"
            >
              <X size={18} />
            </button>
          </header>
          <div className="ram-body">
            <div className="ram-confirm-card">
              <span>Please confirm</span>
              <p>{message}</p>
            </div>
          </div>
          <footer className="ram-footer">
            <button type="button" className="ram-btn ram-btn-quiet" onClick={closeAlert}>
              {cancel || "Cancel"}
            </button>
            <button type="button" className="ram-btn ram-btn-primary" onClick={handleConfirm}>
              {okay || "Confirm"}
            </button>
          </footer>
        </div>
      </Modal>
    );
  }

  return (
    <Modal
      show={show}
      onHide={() => {
        handleClose();
        setReason("");
      }}
      size={`${showReasonBox || editBox ? "lg" : "md"}`}
      centered
    >
      <Modal.Header
        closeButton
        style={heading === "ALERT!!" ? { color: "red" } : { color: "green" }}
      >
        <Modal.Title>{heading}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="newAlert">
        {!editBox ? (
          <div dangerouslySetInnerHTML={{ __html: message }} />
        ) : null}
        {(showReasonBox || editBox) && (
          <div className="mt-3">
            <h6>Reason / Message to Display:</h6>
            <SunEditor
              onChange={(content) => setReason(content)}
              setContents={reason}
              setOptions={{
                height: 300,
                buttonList: [
                  ["undo", "redo"],
                  ["bold", "underline", "italic", "removeFormat"],
                  ["fontColor", "hiliteColor"],
                  ["align", "list", "link"],
                  ["fullScreen", "codeView"],
                ],
              }}
            />
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            handleClose();
            setReason("");
          }}
        >
          {cancel}
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          {okay}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AlertModal;
